import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "phone-input__content" }
const _hoisted_2 = { class: "phone-input__prefix" }
const _hoisted_3 = ["id", "placeholder", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "phone-input__tooltip"
}

import { computed, onMounted, ref } from "vue";
import AccountInput from "./account-input.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'phone-input',
  props: /*@__PURE__*/_mergeModels({
    modelValue: {},
    name: {},
    title: {},
    phoneExtension: {},
    placeholder: {},
    showTooltip: { type: Boolean },
    disabled: { type: Boolean }
  }, {
    "errorMessage": {},
    "errorMessageModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue", "inputKeyUp", "inputErrorDetected"], ["update:errorMessage"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

const errorMessage = _useModel<string>(__props, "errorMessage");

const isPhone = (phone: string) => /^(\d{9})$/.test(phone?.replaceAll(" ", ""));

const modelIsWithPrefix = computed(() => props.modelValue?.length > 3 && props.modelValue[0] == "+");

const phonePrefix = computed(() => {
    return modelIsWithPrefix.value ? props.modelValue.slice(0, 4) : "+420";
});

const phoneValue = computed({
    get() {
        return modelIsWithPrefix.value ? props.modelValue.slice(4) : props.modelValue;
    },
    set(phoneNumber) {
        errorMessage.value = null;
        emit("update:modelValue", phonePrefix.value + phoneNumber);
    },
});

const inputKeyUp = (event: KeyboardEvent) => {
    emit("inputKeyUp", event);
};

const checkIfIsValid = (): boolean => {
    let isValid = true;

    if (!phoneValue.value) {
        errorMessage.value = "Vyplňte vaše telefoní číslo.";
        isValid = false;
    } else if (!isPhone(phoneValue.value)) {
        errorMessage.value = "Chybný formát telefonního čísla.";
        isValid = false;
    }

    return isValid;
};

const inputRef = ref<HTMLInputElement>(null);
onMounted(() => {
    inputRef.value.focus();
});

__expose({
    checkIfIsValid,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["phone-input", { 'phone-input--disabled': _ctx.disabled }])
  }, [
    _createVNode(AccountInput, {
      errorMessage: errorMessage.value,
      name: _ctx.name,
      title: _ctx.title,
      onInputErrorDetected: _cache[1] || (_cache[1] = ($event: any) => (emit('inputErrorDetected', _ctx.name, errorMessage.value)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(phonePrefix.value), 1),
          _withDirectives(_createElementVNode("input", {
            class: "phone-input__input",
            type: "text",
            inputmode: "numeric",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneValue).value = $event)),
            id: _ctx.name,
            placeholder: _ctx.placeholder ?? 'Vaše telefonní číslo',
            maxlength: "9",
            required: "",
            disabled: _ctx.disabled,
            ref_key: "inputRef",
            ref: inputRef,
            onKeyup: inputKeyUp
          }, null, 40, _hoisted_3), [
            [_vModelText, phoneValue.value]
          ])
        ])
      ]),
      _: 1
    }, 8, ["errorMessage", "name", "title"]),
    (_ctx.showTooltip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Na telefon vám v dalším kroku zašleme PIN k ověření."))
      : _createCommentVNode("", true)
  ], 2))
}
}

})